import CustomTabs from '../../../components/common/CustomTabs'
import Title from '../../../components/common/title'
import useSelectedItemSideBar from '../../../hooks/useSelectedItemSideBar'
import DocumentsAcq from './components/documentsAcq'
import DocumentsEntreprise from './components/documentsEntreprise'
import {ActiveEnterpriseContext} from '../../../context/activeEnterpriseContext';
import {useContext, useState} from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import FormikContext from '../../../context/formikContext';
import FieldWithLabel from '../../../components/common/fields/fieldWithLabel';
import OutlinedFieldFormik from '../../../components/formik/fields/outlinedFieldFormik';
import SelectFormik from '../../../components/formik/fields/selectFormik';
import ContainedButton from '../../../components/common/buttons/containedButton';
import ResetButton from '../../../components/common/buttons/resetButton';
import {FilterType} from '../../../types/api';
import {useFormik} from 'formik';
import {useGetDocumentCategoriesQuery} from '../../../hooks/api/entreprises';

const Documents = () => {
  useSelectedItemSideBar('entreprise.documents')
  const isMobile = useMediaQuery('(max-width:800px)')
  const {activeEnterprise} = useContext(ActiveEnterpriseContext)
  const [filter, setFilter] = useState<FilterType>({})

  const { data: documentCategories } = useGetDocumentCategoriesQuery()

  const categories = documentCategories ? 
    documentCategories.map((category) => ({
      id: category.key,
      name: category.title
    })) : []

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      search: '',
      category: '',
    },
    onSubmit: (values) => {
      setFilter(values)
    },
  })

  let customTabs =
    <CustomTabs
      list={[
        {
          label: 'Documents ACQ',
          element: <DocumentsAcq filter={filter}/>,
          width: '219px',
        },
      ]}
    />

  // Show both tabs if user is admin
  if (activeEnterprise.roles.includes('Admin'))
    customTabs = <CustomTabs
        list={[
          {
            label: 'Documents entreprise',
            element: <DocumentsEntreprise filter={filter} />,
            width: '255px',
          },
          {
            label: 'Documents ACQ',
            element: <DocumentsAcq filter={filter} />,
            width: '219px',
          },
        ]}
      />

  return (
    <>
      <Title>Documents</Title>
      <Typography variant='h3' mb='19px'>
        Rechercher ou filtrer
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ 
          display: 'flex', 
          gap: isMobile ? '16px' : '24px', 
          mb: '48px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'stretch' : 'flex-end'
        }}>
          <FormikContext.Provider value={formik}>
            <FieldWithLabel label='Mots clés'>
              <OutlinedFieldFormik
                sx={{ width: isMobile ? '100%' : '320px', mt: '-12px' }}
                name='search'
                placeholder='Nom, sujet, note'
              />
            </FieldWithLabel>
            <FieldWithLabel label='Catégorie'>
              <SelectFormik
                sx={{ width: isMobile ? '100%' : '320px', mt: '-12px' }}
                name='category'
                listItems={categories}
              />
            </FieldWithLabel>
            <ContainedButton
              sx={{ 
                alignSelf: 'end', 
                width: isMobile ? '100%' : '158px', 
                minHeight: '42px', 
                height: '42px', 
                py: '6px' 
              }}
              title='rechercher'
              handleClick={() => formik.handleSubmit()}
              type='submit'
            />
          </FormikContext.Provider>
        </Box>
      </form>
      {(formik.dirty || Object.keys(filter).length > 0) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            mb: '16px',
          }}
        >
          <Typography sx={{ fontWeight: '500' }}>
            Filtres appliqués
          </Typography>
          <ResetButton
            handleClick={() => {
              setFilter({})
              formik.resetForm()
            }}
          />
        </Box>
      )}
      {customTabs}
    </>
  )
}

export default Documents
